import React, { forwardRef } from 'react';
import { motion, HTMLMotionProps } from 'framer-motion';
import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';
function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
interface CardProps extends HTMLMotionProps<'div'> {
  hoverable?: boolean;
}
export const Card = forwardRef<HTMLDivElement, CardProps>(({
  className,
  hoverable,
  children,
  ...props
}, ref) => {
  return <motion.div ref={ref} whileHover={hoverable ? {
    y: -4
  } : undefined} className={cn('bg-white rounded-2xl border border-sage-light shadow-card overflow-hidden', className)} {...props} data-id="element-440">
        {children}
      </motion.div>;
});
Card.displayName = 'Card';